import { useState } from 'react'
import type { FormEvent } from 'react'
import type { PuzzleRendererProps } from '@/game/PuzzleRenderer'

type Config = { placeholder?: string; unit?: string; min?: number; max?: number; step?: number; integerOnly?: boolean }

/** Numeric answer. Submits { number }. Validation modes live server-side. */
export function NumberPuzzle({ puzzle, onSubmit, disabled }: PuzzleRendererProps) {
  const config = puzzle.publicConfig as Config
  const [raw, setRaw] = useState('')
  const valid = raw.trim() !== '' && Number.isFinite(Number(raw))

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    if (!valid) return
    void onSubmit({ number: Number(raw) })
  }

  return (
    <form onSubmit={handleSubmit} className="puzzle-form">
      <div className="field">
        <label htmlFor={`number-${puzzle.id}`}>Your answer{config.unit ? ` (${config.unit})` : ''}</label>
        <input
          id={`number-${puzzle.id}`}
          type="number"
          inputMode={config.integerOnly ? 'numeric' : 'decimal'}
          step={config.step ?? (config.integerOnly ? 1 : 'any')}
          min={config.min}
          max={config.max}
          placeholder={config.placeholder}
          value={raw}
          onChange={(e) => setRaw(e.target.value)}
          disabled={disabled}
          enterKeyHint="send"
        />
      </div>
      <button type="submit" className="primary" disabled={disabled || !valid}>
        {disabled ? 'Checking…' : 'Submit answer'}
      </button>
    </form>
  )
}
